module.exports = "/images/logo_beecrm_new_colors.png?2e24c29d9c354f7ecf3d8caad61fa1b8";